<modal class="has-text-left">
    @if (isSummerEdition) {
        <dl class="dl is-alternate">
            <dt class="is-3 text">40 Go utilisables depuis plus de 110 destinations à l&apos;étranger&nbsp;:</dt>
            <dd>
                @for (entry of locationEntries; track entry[0]) {
                    <b>{{entry[0]}}&nbsp;:</b>&nbsp;{{entry[1]}}
                }
            </dd>
        </dl>
    } @else {
        <checkout-cms-block [blockId]="europeDestinationsCmsBlockId" [battlefront]="false" />
    }
</modal>
